export default __webpack_public_path__ + "static/media/fxPickup.91b1fd73.mp3";